var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRemove = function SvgRemove(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6076",
    "data-name": "Group 6076",
    transform: "translate(-267 -428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "error_1_",
    "data-name": "error (1)",
    transform: "translate(267 428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77895",
    "data-name": "Path 77895",
    d: "M17.074,2.925a10,10,0,1,0,0,14.149A10.016,10.016,0,0,0,17.074,2.925Zm-3.129,11.02a.769.769,0,0,1-1.088,0L10,11.088,7.007,14.081a.769.769,0,0,1-1.088-1.088L8.912,10,6.055,7.143A.769.769,0,1,1,7.143,6.055L10,8.912l2.721-2.721a.769.769,0,0,1,1.088,1.088L11.088,10l2.857,2.857A.769.769,0,0,1,13.945,13.945Z",
    transform: "translate(0 0)",
    fill: "#ff7f7f"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRemove, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/remove.e789555f.svg";
export { ForwardRef as ReactComponent };